import { domReady } from '@/utils/dom-ready'
import { Modal } from 'bootstrap'

domReady(() => {
  // For inappropriate petitions, show the modal explaining that it's inappropriate,
  // with the contact form to send a message to admins about it.
  const prohibitedPetitionModalEl = document.getElementById('prohibited-petition-modal')
  if (prohibitedPetitionModalEl) {
    Modal.getOrCreateInstance(prohibitedPetitionModalEl, {backdrop: 'static', keyboard: false}).show()
  }
})
